import { config } from "core/config/app";
import PersonalChannelPage from "./pages/PersonalChannelPage";
import PostDetailPage from "./pages/PostDetailPage";
import CommunityListPage from "./pages/CommunityListPage";
import CommunityCreatePage from "./pages/CommunityCreatePage";
import CommonPhase4 from "./pages/CommonPhase4";

const router = [
  {
    name: "CommonPhase4",
    exact: true,
    path: `${config?.basename}/CommonPhase4`,
    element: <CommonPhase4 />,
  },
  {
    name: "POST_DETAIL",
    // auth: true,
    exact: true,
    path: `${config?.basename}/community/detail/:id`,
    element: <PostDetailPage />,
  },
  {
    name: "PERSONAL_CHANNEL",
    // auth: true,
    exact: true,
    path: `${config?.basename}/community/personal-channel/:id`,
    element: <PersonalChannelPage />,
  },
  {
    name: "COMMUNITY_LIST",
    // auth: true,
    exact: true,
    path: `${config?.basename}/community/list`,
    element: <CommunityListPage />,
  },
  {
    name: "COMMUNITY_CREATE",
    auth: true,
    exact: true,
    path: `${config?.basename}/community/create`,
    element: <CommunityCreatePage />,
  },
];
export default router;
